import { Spin } from 'antd';
import styles from './index.module.scss';

export default function CustomSpin({ loading = false, customClass = '', customStyle = {} }: any) {
    // 自定义类名
    const className = `${styles.customSpin} ${customClass}`;
    return <Spin className={className} spinning={loading} style={customStyle} />;
}
